import { apiClient, OAUTH_BINDING_API_BASE } from '../../services/apiClient';

/** YouTube 連携ステータス */
export interface YouTubeAuthStatus {
  connected: boolean;
  channel_title: string | null;
}

/** YouTube 認証URL */
export interface YouTubeAuthUrl {
  url: string;
}

/** YouTube 連携ステータスを取得 */
export async function getYouTubeAuthStatus(): Promise<YouTubeAuthStatus> {
  const { data } = await apiClient.get<YouTubeAuthStatus>('/youtube/auth/status');
  return data;
}

/** YouTube 認証URLを取得 */
export async function getYouTubeAuthUrl(): Promise<YouTubeAuthUrl> {
  // 結合 Cookie を first-party にするため同一オリジン経由 (apiClient.ts 参照)
  const { data } = await apiClient.get<YouTubeAuthUrl>('/youtube/auth/url', { baseURL: OAUTH_BINDING_API_BASE });
  return data;
}

/** YouTube 連携を解除 */
export async function disconnectYouTube(): Promise<{ success: boolean }> {
  const { data } = await apiClient.post<{ success: boolean }>('/youtube/disconnect');
  return data;
}
